/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Newsletter_Resubscribe_Done_TitleInputs */

const en_newsletter_resubscribe_done_title = /** @type {(inputs: Newsletter_Resubscribe_Done_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welcome back`)
};

/**
* | output |
* | --- |
* | "Welcome back" |
*
* @param {Newsletter_Resubscribe_Done_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const newsletter_resubscribe_done_title = /** @type {((inputs?: Newsletter_Resubscribe_Done_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Newsletter_Resubscribe_Done_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_newsletter_resubscribe_done_title(inputs)
});